import React from 'react';

import './video-embed.scss';

type VideoEmbedProps = {
  src: string;
  title: string;
};

export function VideoEmbed(props: VideoEmbedProps): JSX.Element {
  const { src, title } = props;
  return (
    <div className="video-wrapper">
      <iframe
        src={src}
        title={title}
        className="culture-video"
        allow="fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
